import { z } from "zod";
import { createApiResponseSchema } from "../common/pagination";
import { faqItemSchema } from "@/schemas/fag";

export type FaqGroupedItem = {
  category: string;
  items: {
    value: string;
    title: string;
    content: string;
    order?: number;
  }[];
};

export type FaqItemType = z.infer<typeof faqItemSchema>;

export const ApiFaqResponseSchema = createApiResponseSchema(faqItemSchema);
export type ApiFaqlResponseType = z.infer<typeof ApiFaqResponseSchema>;
